import { DAYS_FETCH_REQUEST, DAYS_FETCH_SUCCESS, DAYS_FETCH_FAILURE } from './types';

const initialState = {
    loading: false,
    days: [],
    error: ''
}

const days = (state = initialState, action) => {
    switch (action.type) {
        case DAYS_FETCH_REQUEST:
            return {
                loading: true,
                days: [],
                error: '',
            }
        case DAYS_FETCH_SUCCESS:
            return {
                loading: false,
                days: action.payload,
                error: ''
            }
        case DAYS_FETCH_FAILURE:
            return {
                loading: false,
                days: {},
                error: action.payload
            }
        default: return state
    }
}

export default days;